<template>
    <footer class="footer" v-if="data">
        <div class="inner">
            <div class="cols">
                <h2 class="col-3-2 name"><router-link to="/">{{$store.state.site_name}}<p>{{$store.state.site_description}}</p></router-link></h2>
                <ul class="col-3-1 medias">
                    <li v-if="data.medias.instagram">
                        <a :href="data.medias.instagram" target="_black">
                            <SvgIcon name="instagram" />
                        </a>
                    </li>
                    <li v-if="data.medias.facebook">
                        <a :href="data.medias.facebook" target="_black">
                            <SvgIcon name="facebook" />
                        </a>
                    </li>
                    <li v-if="data.medias.twitter">
                        <a :href="data.medias.twitter" target="_black">
                            <SvgIcon name="twitter" />
                        </a>
                    </li>
                    <li v-if="data.medias.vimeo">
                        <a :href="data.medias.vimeo" target="_black">
                            <SvgIcon name="vimeo" />
                        </a>
                    </li>
                </ul>
                <nav class="col-3-2 menu">
                    <ul v-if="data.menu.length !== 0">
                        <li v-for="(item, index) in data.menu" :key="index">
                            <Link :post_link="item.menu_item.url" v-html="item.menu_item.title.replace('&#8232;', '')"></Link>
                        </li>
                    </ul>
                </nav>
                <div class="col-3-1 newsletter">
                    <p>subscribe to our newsletter for updates, news and research </p>
                    <form id="subscribe-email" ref="form" @submit="newsletter($event)">
                        <div style="position: absolute; left: -5000px;" aria-hidden="true">
                            <input type="text" :name="mid" tabindex="-1" value="">
                        </div>
                        <input class="email" name="EMAIL" type="email" v-model="email"  placeholder="enter email here" required><br />
                        <button type="submit">join</button>
                        <span class="result" ref="result"></span>
                    </form>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import jsonp from 'jsonp';
import Link from '@/components/ui/Link.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';

export default {
    name: 'Footer',

    data() {
        return {
            data: false,
            is_show: false,
            is_ok: false,
            email: '',
            errmsg: '',
            api: 'https://myshopify.us8.list-manage.com/subscribe/post-json?u=d8ea9a5d97c5b570cb6eae978&amp;id=000a1e14f1&amp;c=?',
            mid: 'b_d8ea9a5d97c5b570cb6eae978_000a1e14f1',
        }
    },

    components: {
        Link,
        SvgIcon,
    },

    methods: {
        newsletter ($event) {
            const form = this.$refs.form
            const result = this.$refs.result
            const api = this.api

            result.innerHTML = 'Sending...';

            jsonp(api + '&' + new URLSearchParams(new FormData(form)).toString(), { param: 'c' }, (err, data) => {
                if (data.result === 'error') {
                    result.innerHTML = data.msg.substring(4);
                } else {
                    result.innerHTML = 'Thanks!';
                }
            });

            $event.preventDefault();
        },
    },

    mounted() {
        this.$ajax.get('/footer-options').then(res => {
            this.data = res.data;
            this.$store.state.cookies = res.data.cookies;
        });
    },
}
</script>
<style lang="scss">
    
    .footer {
        background: white;
        padding-top: var(--padding-x2);
        padding-bottom: var(--padding-x2);
        font-weight: bold;
        line-height: 1.3;
        text-transform: lowercase;

        .name {
            font-size: var(--base-size);
            height: 10rem;

            p {
                color: var(--gray);
            }
        }

        .medias {
            display: flex;
            align-items: center;
            margin: .5rem 0 0;

            li {
                padding-right: var(--padding);
            }

            a {
                display: block;
                width: 3.2rem;
                height: 3.2rem;

                svg {
                    height: 100%;
                    width: 100%;
                }
            }
        }

        .menu {
            ul {
                display: flex;
                flex-wrap: wrap;

                li {
                    width: 50%;

                    .router-link-active,
                    .router-link-exact-active {
                        color: var(--yellow);
                    }
                }
            }
        }

        .newsletter {
            form {
                display: flex;
                align-items: center;
            }

            input {
                font-weight: bold;
                border: none;
                background: transparent;
                padding: 0;
                margin: 0;
                font-size: var(--base-size);
                width: 20rem;
            }

            button {
                color: var(--yellow);
                cursor: pointer;
                border: none;
                background: transparent;
                font-family: var(--font);
                font-weight: bold;
                font-size: var(--base-size);
            }

            .result {
                display: inline-block;
                padding-left: var(--padding);
                font-size: var(--base-size);
                color: var(--small-size);
            }
        }

    }

    @media only screen and (max-width: 780px) {
        .footer {
            padding-top: var(--padding-x2);
            padding-bottom: var(--padding-x2);

            .name {
                height: auto;
                padding-bottom: var(--padding);
            }

            .medias {
                margin: 0 0 1rem;
                padding-bottom: var(--padding);

                li {
                    padding-right: var(--padding);
                }

                a {
                    width: 6rem;
                    height: 6rem;
                }
            }

            .menu {
                padding-bottom: var(--padding);

                ul {
                    display: block;
                    flex-wrap: wrap;

                    li {
                        width: 100%;
                        padding-bottom: var(--padding-50);
                    }
                }
            }

            .newsletter {

                input {
                    width: 32rem;
                }
            }

        }
    }
</style>

